import type { FieldTypeCard, ValueKind } from '../field-types/card';
import { USER_PLACEHOLDERS } from '../texts/userPlaceholders';

export const isFilled = (card: FieldTypeCard, value: unknown): value is NonNullable<unknown> => {
  return value !== undefined && value !== null && !card.isEmpty(value);
};

export const requiredText = (valueKind: ValueKind): string => {
  return valueKind === 'rows' ? USER_PLACEHOLDERS.required.rows : USER_PLACEHOLDERS.required.field;
};
